import CheckEmail from "./CheckEmail";

export default CheckEmail;